/** Pause dashboard polling/sockets immediately when navigating away from /dashboard. */

let paused = false;
/** @type {Set<() => void>} */
const listeners = new Set();

function notifyListeners() {
  listeners.forEach((fn) => {
    try {
      fn();
    } catch {
      /* noop */
    }
  });
}

export function isDashboardPollingActive() {
  return !paused;
}

/** @param {() => void} listener */
export function subscribeDashboardActivity(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function disconnectTradingSocket() {
  if (typeof window === "undefined") return;
  void import("@/utils/socketService")
    .then(({ default: socketService }) => {
      socketService.disconnect();
    })
    .catch(() => {});
}

/** Call before route change off /dashboard (link click or pathname change). */
export function suspendDashboardActivity() {
  if (paused) return;
  paused = true;
  disconnectTradingSocket();
  notifyListeners();
}

/** Re-enable polling when user lands on /dashboard again. */
export function resumeDashboardActivity() {
  if (!paused) return;
  paused = false;
  notifyListeners();
}

export function isInternalAppHref(href) {
  if (!href || typeof href !== "string") return false;
  if (href.startsWith("#")) return false;
  if (href.startsWith("mailto:") || href.startsWith("tel:")) return false;
  if (href.startsWith("http://") || href.startsWith("https://")) {
    try {
      const url = new URL(href);
      return (
        typeof window !== "undefined" && url.origin === window.location.origin
      );
    } catch {
      return false;
    }
  }
  return href.startsWith("/");
}
